import { render } from "./DefaultIndex.vue?vue&type=template&id=136e0a08&scoped=true"
import script from "./DefaultIndex.vue?vue&type=script&lang=js"
export * from "./DefaultIndex.vue?vue&type=script&lang=js"

import "./DefaultIndex.vue?vue&type=style&index=0&id=136e0a08&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136e0a08"]])

export default __exports__